<template>
  <div>
    <!-- listar temas -->

    <v-form ref="formDatos" lazy-validation>
      <v-dialog v-model="estadoModal" persistent scrollable max-width="75%">
        <v-card>
          <v-card-title class="modal_title py-5 mb-2">
            <v-row class="d-flex justify-space-between py-0">
              {{ formTitle }}
              <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col class="py-0" style="padding-top: 20px !important">
                <v-autocomplete v-model="malla.id_nivel" label="Nivel:" :items="nivel" item-value="id"
                  item-text="desc_nivel" autocomplete="off" @change="filtrarXGradosNivel()" :disabled="inhabilitarNivel">
                </v-autocomplete>
              </v-col>

              <v-col class="py-0" style="padding-top: 20px !important">
                <v-autocomplete v-model="malla.id_grado" label="Grados:" :items="filtroGrado" item-value="id"
                  item-text="desc_grado" autocomplete="off" @change="filtrarAreasXNiveles()" :disabled="inhabilitarGrado">
                </v-autocomplete>
              </v-col>

              <v-col class="py-0" style="padding-top: 20px !important">
                <v-autocomplete v-model="malla.id_area" label="Áreas:" :items="filtroArea" item-value="id"
                  item-text="desc_area" autocomplete="off" @change="filtrarCursosXAreas()" :disabled="inhabilitarArea">
                </v-autocomplete>
              </v-col>

              <v-col class="py-0" style="padding-top: 20px !important">
                <v-autocomplete v-model="malla.id_curso" :label="$t('titulo.curso')" :items="filtroCurso" item-value="id"
                  item-text="desc_curso" @change="ObtenerClases()" autocomplete="off" :disabled="inhabilitarCurso">
                </v-autocomplete>
              </v-col>

              <v-col cols="4" md="" class="py-0" style="padding-top: 20px !important">
                <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line
                  hide-details></v-text-field>
              </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="datos" :search="search" class="elevation-1 black--text" fixed-header>
              <template v-slot:[`item.importar`]="{ item }">
                <v-btn class="btn_block_style2" small @click="confirmImportarTema(item)">
                  IMPORTAR TEMA</v-btn>
              </template>

              <template v-slot:[`item.action_clases`]="{ item }">
                <v-tooltip bottom color="#1b1b1b">
                  <template v-slot:activator="{ on }">
                    <v-btn v-if="componenteEvento.visualizar_submodulo" @click="visualizarClase(item)" v-on="on"
                      class="btn_ver mx-auto mb-1" fab x-small>
                      <v-icon>fa-eye</v-icon>
                    </v-btn>
                  </template>
                  <span class="text-uppercase">VER CLASE</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-form>

    <!-- fin consulta -->

    <!----------  SECCION DE MODALES   -------->
    <!-- modal confirmacion Importar Tema -->
    <v-form ref="formTema" lazy-validation>
      <v-dialog v-model="importarTema" persistent scrollable max-width="800px">
        <v-card>
          <v-card-title class="modal_title py-5 mb-2">
            <v-row class="d-flex justify-space-between py-0">
              {{ importarTemaTitle }}
              <v-btn fab dark x-small class="btn_style3" @click="importarTema = false"><v-icon
                  dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="6" class="py-0" style="padding-top: 20px !important">
                <v-text-field v-model="datosDetalles.desc_nivel
                  " label="Nivel" readonly></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="py-0" style="padding-top: 20px !important">
                <v-text-field v-model="datosDetalles.desc_grado" label="Grado" readonly></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field v-model="datosDetalles.desc_area" label="Área" readonly></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field v-model="datosDetalles.nombre_tema" label="Unidad" readonly></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field v-model="tema_clase" label="Tema seleccionado" readonly></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="6" class="py-0">
                <v-text-field v-model="datosDetalles.orden" label="Orden" type="number" min="0"
                  @keypress="soloNumeros($event)"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn class="btn_block_style2" @click="saveItem()" :loading="loading"
              :disabled="inhabilitarButton">Importar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>

    <!-- --------------------------->

    <component :is="compName" :estadoComp="estadoModalConfig" @close="estadoModalConfig = false"
      :parametros="parametroConfigVisor">
    </component>
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import visorContenidoCk1 from "@/views/Manager/GestionContenido/viewGC/visorGestorContenido";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "ImportarContenido",

  props: ["estadoModal", "parametros", "evento"],

  components: { visorContenidoCk1 },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    rutaservidor: `${API_URL}/`,
    paramComponente: { id_modulo: 7, id_submodulo: 64 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,

    loading: false,
    inhabilitarButton: false,
    malla: [],
    search: "",
    nivel: [],
    grado: [],
    areaNivel: [],
    areaGrado: [],
    cursos: [],

    filtroArea: [],
    filtroGrado: [],
    filtroCurso: [],

    datos: [],
    datosTemaCk1: [],

    datosResp: [],

    inhabilitarNivel: true,
    inhabilitarGrado: true,
    inhabilitarArea: true,
    inhabilitarCurso: true,

    importarTema: false,
    importarTemaTitle: "Importar tema",
    tema_clase: "",

    datosDetalles: {
      desc_nivel: '',
      desc_grado: '',
      desc_area: '',
      nombre_tema: '',
      orden: null,
    },
    /////////////////////////
    // visor de contenidos
    compName: "",
    estadoModalConfig: false,
    parametroConfigVisor: [],

    visor: false,
    api_list_contenidos: [],
    tipoVisor: "",
    ///////////////////////////

    headers: [
      // { text: 'NIVEL', value: 'desc_nivel', sortable: false,  class:'secondary black--text',align:'center'},
      // { text: 'GRADO', value: 'desc_grado', sortable: false,  class:'secondary black--text',align:'center'},
      // { text: 'AREA', value: 'desc_area', sortable: false,  class:'secondary black--text',align:'center'},
      // { text: 'CURSO', value: 'desc_curso', sortable: false,  class:'secondary black--text',align:'center'},
      {
        text: "UNIDAD",
        value: "nombre_tema",
        sortable: false,
        class: "secondary black--text",
        align: "center",
      },
      {
        text: "TEMA",
        value: "nombre_clase",
        sortable: false,
        class: "secondary black--text",
        align: "center",
      },
      {
        text: "IMPORTAR",
        value: "importar",
        sortable: false,
        class: "secondary black--text",
        align: "center",
      },
      {
        text: "VER CLASES",
        width: "1",
        value: "action_clases",
        sortable: false,
        class: "secondary black--text",
        align: "center",
      },
    ],

    formTitle: "Importar tema del megaportal educativo de inteligenio",
  }),

  //computadas
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },

  watch: {
    estadoModal(flag) {
      if (flag) {
        this.loadMain();
      }
    },

  },
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
    // -- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-- cargar Parametros de inicio del componente --
    async loadMain() {

      this.limpiarForm();
      this.getQuery();
    },

    async getQuery() {
      try {
        this.inhabilitarNivel = false;
        this.inhabilitarGrado = true;
        this.inhabilitarArea = true;
        this.inhabilitarCurso = true;

        this.malla.id_nivel = "";
        this.malla.id_grado = "";
        this.malla.id_area = "";
        this.malla.id_curso = "";
        this.datos = [];

        let response = await axios.post(
          `/academico/mallaCurricular/getImporterQueryCk1`,
          {
            id_usuario: this.datoLogin.id,
            id_colegio: this.datoLogin.id_colegio,
            id_periodo: this.datoLogin.id_ano_lectivo,
          }
        );
        this.nivel = response.data.Nivel;
        this.grado = response.data.Grado;
        this.areaNivel = response.data.AreaNivel;
        this.areaGrado = response.data.AreaGrado;
        this.cursos = response.data.Cursos;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    // fitrar grados y areas por niveles
    filtrarXGradosNivel() {
      this.inhabilitarGrado = false;
      this.inhabilitarArea = false;
      this.inhabilitarCurso = true;
      this.malla.id_area = "";
      this.malla.id_curso = "";
      this.datos = [];

      // filtro de grados por niveles
      this.filtroGrado = this.grado.filter(
        (el) => el.id_nivel == this.malla.id_nivel
      );
      // filtro de areas por niveles
      this.filtroArea = this.areaNivel.filter(
        (el) => el.id_nivel == this.malla.id_nivel
      );
    },

    // traer las areas por grados
    filtrarAreasXGrados() {
      this.inhabilitarArea = false;
      this.inhabilitarCurso = true;
      this.malla.id_curso = "";
      this.malla.id_area = "";
      this.datos = [];

      this.filtroArea = this.areaGrado.filter(
        (el) => el.id_grado == this.malla.id_grado
      );
    },

    //traer area por niveles
    filtrarAreasXNiveles() {
      this.inhabilitarArea = false;
      this.inhabilitarCurso = true;
      this.malla.id_curso = "";
      this.malla.id_area = "";
      this.datos = [];
      this.filtroArea = this.areaNivel.filter(
        (el) =>
          el.id_nivel == this.malla.id_nivel &&
          el.id_grado == this.malla.id_grado
      );
    },

    // traer los cursos
    async filtrarCursosXAreas() {
      // los cursos se tienen que filtrar por grados y area
      this.inhabilitarCurso = false;
      this.malla.id_curso = "";
      // filtro por grado

      let filtroCursoGrado = this.cursos.filter(
        (el) => el.id_grado == this.malla.id_grado
      );
      // filtro por Area
      this.filtroCurso = filtroCursoGrado.filter(
        (el) => el.id_area == this.malla.id_area
      );

      await this.ObtenerClases();
    },

    // obterner las clases de los gestor de contenidos segun los filtros seleccionados
    async ObtenerClases() {
      try {
        // let params = Object.assign({periodo: this.datoLogin.id_ano_lectivo}, this.asociarCl)
        // contenido clicken 1

        let response = await axios.post(
          `/academico/mallaCurricular/getClasesCk1`,
          this.malla
        );

        this.datos = response.data.Clases;
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
      }
    },

    limpiarForm() {
      this.nivel = [];
      this.grado = [];
      this.areas = [];
      this.cursos = [];

      this.malla = {
        id_nivel: "",
        id_grado: "",
        id_area: "",
        id_curso: "",
        contenidoTipo: "",
        periodo: this.datoLogin.id_ano_lectivo,
        id_usuario: this.datoLogin.id,
      };

      this.inhabilitarNivel = true;
      this.inhabilitarGrado = true;
      this.inhabilitarArea = true;
      this.inhabilitarCurso = true;
    },

    //////////////////////////////////////
    // VISOR DE CONTENIDO DEL COLEGIO Y MANAGER

    // botos para visualizar clases de la programacion de contenido
    async visualizarClase(item) {

      this.parametroConfigVisor = {
        id_clase: item.id_clase,
        evento: "view",
        miniatura: false,
        id_diapositiva: 0,
        tipo_contenido: "manager",
      };

      this.compName = "visorContenidoCk1";
      this.estadoModalConfig = true;

    },

    // funcion para cerrar modal
    cerrarVisor() {
      this.visor = false;
      this.api_list_contenidos = [];
      this.tipoVisor = "";
      //this.setCloseVisor()
    },

    async confirmImportarTema(item) {

      this.datosDetalles.desc_nivel = item.desc_nivel,
        this.datosDetalles.desc_grado = item.desc_grado,
        this.datosDetalles.desc_area = item.desc_area,
        this.datosDetalles.nombre_tema = item.nombre_tema,
        this.datosDetalles.orden = item.orden_clase,

        this.importarTema = true;

      this.tema_clase = item.nombre_clase;
      this.datosTemaCk1 = item;
      //nombre_tema nombre_clase
      // alert(`"nombre_tema": "Unidad I: Las artes visuales", "id_clase": 3857, "nombre_clase":"`)
    },

    async saveItem() {
      try {
        this.loading = true;
        this.inhabilitarButton = true;

        let paramsColegio = {
          id_usuario: this.datoLogin.id,
          id_ano_lectivo: this.datoLogin.id_ano_lectivo,
          id_colegio: this.datoLogin.id_colegio,
        };

        let datosImportar = Object.assign(paramsColegio, this.parametros);
        // contenido clicken 1
        let params = { datosTemaCk1: this.datosTemaCk1, datosImportar };

        let response = await axios.post(
          `/administrativo/contenido/importar`,
          params
        );
        this.loading = false;
        this.inhabilitarButton = false;
        this.parametros.orden++;

        this.datosResp = response.data;

        this.setEnviarMens({
          tipo: "S",
          mensaje: `${response.data.message}`,
          tiempo: null,
        });

        this.$emit("reloadComp", datosImportar.id);
        // this.$emit("updateClases", response.data.datosColegio);
        this.importarTema = false;

      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          mensaje: `Error: ${error}`,
          tiempo: null,
        });
        this.loading = false;
        this.inhabilitarButton = false;
      }
    },

    soloNumeros(event) {
      var key = window.event ? event.which : event.keyCode;
      if (key < 48 || key > 57) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped></style>